import EditAnnouncement from "../components/EditAnnouncement";

function EditPoster() {
  return (
    <div>
      <EditAnnouncement />
    </div>
  );
}

export default EditPoster;
